import { render, staticRenderFns } from "./ShiftView.vue?vue&type=template&id=67224824&scoped=true"
import script from "./ShiftView.vue?vue&type=script&lang=js"
export * from "./ShiftView.vue?vue&type=script&lang=js"
import style0 from "./ShiftView.vue?vue&type=style&index=0&id=67224824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67224824",
  null
  
)

export default component.exports